import Vue from 'vue';
import Vuex from 'vuex';

import employees from './crm/employees';
import customers from './crm/customers';
import contacts from './crm/contacts';
import providers from './crm/providers';

import financial from './financial';
import receivables from './financial/receivables';
import invoices from './financial/invoices';
import refunds from './financial/refunds';
import refund_notes from './financial/refund_notes';
import refund_notes_open from './financial/refund_notes_open';
import refund_notes_employees from './financial/refund_notes_employees';
import refund_notes_employees_open from './financial/refund_notes_employees_open';
import expense_notes from './financial/expense_notes';
import expense_notes_open from './financial/expense_notes_open';
import expenses from './financial/expenses';
import money_boxes from './financial/money_boxes';

import contracts from './contracts';

import timesheet from './timesheet/timesheet';
import timesheet_reports from './timesheet/reports';
import auth from './auth';

import folders from './folders';

import axios from 'axios';

const colors = {
  'OK': 'green',
  'NO': 'red',
}

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    settings: {},
    departments: [],
    phoneTypes: [],
    breadcrumbs: [],
    counters: {
      nr_customer_count: 0,
      nr_employee_count: 0,
      nd_employee_count: 0,
      contract_expire_count: 0,
    },
    errorMessage: {
      title: '',
      message: '',
    },
  },
  mutations: {
    SET_SETTINGS(state, obj) {
      state.settings = obj;
    },
    SET_DEPARTMENTS(state, obj) {
      state.departments = obj;
    },
    SET_PHONETYPES(state, obj) {
      state.phoneTypes = obj;
    },
    SET_BREADCRUMBS(state, obj) {
      state.breadcrumbs = obj;
    },
    SET_COUNTERS(state, obj) {
      state.counters = obj;
    },
    SET_ERROR_MESSAGE(state, obj) {
      state.errorMessage = obj;
    },
  },
  actions: {
    loadSettings(options) {
      // axios.get('/settings').then(res => {
      //   options.commit('SET_SETTINGS', res.data.data);
      // })
      options.commit('SET_SETTINGS', colors);
      // Usar como
      // this.$store.settings.ok
    },
    loadPhoneTypes(options) {
      axios.get('/crm/phonetype/').then(response => {
        options.commit('SET_PHONETYPES', response.data.data);
      })
    },
    loadDepartments(options) {
      axios.get('/crm/departments/').then(response => {
        options.commit('SET_DEPARTMENTS', response.data.data);
      })
    },
    loadCounters(options) {
      axios.get('/counters/').then(response => {
        options.commit('SET_COUNTERS', response.data);
      })
    },
    setBreadcrumbs(options, obj) {
      options.commit('SET_BREADCRUMBS', obj);
    },
    setError(options, obj) {
      options.commit('SET_ERROR_MESSAGE', obj);
    }
  },
  modules: {
    employees,
    customers,
    contacts,
    providers,
    financial,
    invoices,
    receivables,
    refunds,
    refund_notes,
    refund_notes_open,
    refund_notes_employees,
    refund_notes_employees_open,
    expense_notes,
    expense_notes_open,
    expenses,
    money_boxes,
    contracts,
    timesheet,
    timesheet_reports,
    folders,
    auth,
  },
});
